<template>
    <VJoyTemplate class="landing-sitemap">
        <template #template-title>
            <h1>{{ $t('sitemap.freelancers.tags') }}</h1>
        </template>
        <template #template-subtitle>
            <p>{{ $t('acquisition.banner.subtitle') }}</p>
        </template>
        <template #template-main>
            <SearchBlock page="freelancers_tags" />
            <div class="landing-sitemap__header">
                <h2>{{ $t('sitemap.categories.intro.title') }}</h2>
                <p>{{ $t('sitemap.tags.intro') }}</p>
            </div>
            <ul class="landing-sitemap__list">
                <li v-for="entry in tagEntries" :key="entry.url">
                    <VJoyLink v-if="entry.url" :href="$withLocalePrefix(entry.url)">{{ entry.label }}</VJoyLink>
                </li>
            </ul>
        </template>
    </VJoyTemplate>
</template>

<script setup lang="ts">
    import {createError, useAsyncData} from '#app';
    import {SearchBlock} from '#components';
    import {useTranslation, useSeoMeta, useTwitterMetaTags, TwitterMetaTags, useOpenGraphMetaTags, OpenGraphMetaTag, useLocale} from '#imports';
    import {VJoyTemplate, VJoyLink} from '@maltjoy/core-vue';
    import {Configuration, SitemapApi} from '@api';

    const {t} = useTranslation();

    /* seo */
    const {isMultiLocaleHost} = useLocale();
    const title = t('sitemap.freelancers.tags');
    const description = t('acquisition.banner.subtitle');
    useSeoMeta({
        ...(isMultiLocaleHost.value && {robots: 'noindex'}),
        title,
        description,
    });
    useTwitterMetaTags(new TwitterMetaTags({card: 'summary', title, description, t}));
    useOpenGraphMetaTags(new OpenGraphMetaTag({title, description, t}));

    /* data */
    const configuration = new Configuration({basePath: ''});
    const sitemapApi = new SitemapApi(configuration);
    const {data: tagEntries, error} = await useAsyncData(() => sitemapApi.getFreelancerTags(), {deep: true});
    if (error.value) {
        throw createError(error.value);
    }
</script>

<style lang="scss">
    @use '~/assets/styles/sitemap.scss';
</style>
